import { Link } from "react-router-dom";
import ShellCard from "../../components/ShellCard";
import heroBanner from "../../assets/images/pages/dui-level1.jpg";

const DuiLevel1 = () => {
  return (
    <>
      <section className="hero-slider-section">
        <div
          className="hero-banner"
          style={{
            backgroundImage: `url(${heroBanner})`,
          }}
        >
          <div className="banner-text-container">
            <div className="banner-heading">
              <h1 className="banner-title">DUI Level 1 – 12 Hour Program</h1>
              <p className="banner-subheading">
                Court-ordered or DMV-mandated after the first DUI or Drug
                related arrest
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5" style={{ backgroundColor: "#111111" }}>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ShellCard>
                <div className="mb-4">
                  <h3 className="mb-3" style={{ color: "var(--metro-yellow)" }}>
                    Description
                  </h3>
                  <p className="text-white mb-3">
                    Court-ordered or DMV-mandated after the first DUI or Drug
                    related arrest.
                  </p>
                  <p className="text-white mb-0">
                    Both the class and evaluation portion of the DUI Level I
                    program are available in English or Spanish. You will be
                    able to select a class that is offered in the language you
                    prefer.
                  </p>
                </div>

                <div
                  className="p-4 mb-4"
                  style={{
                    backgroundColor: "#333333",
                    border: "1px solid var(--metro-yellow)",
                    borderRadius: "8px",
                  }}
                >
                  <h4 className="h5 mb-4" style={{ color: "var(--metro-yellow)" }}>
                    <i className="fas fa-clock me-2"></i>
                    Length
                  </h4>
                  <div className="mb-3">
                    <i
                      className="fas fa-chalkboard-teacher me-2"
                      style={{ color: "var(--metro-yellow)" }}
                    ></i>
                    <span className="text-white">
                      12 hours of class and 1 hour evaluation
                    </span>
                  </div>
                  <div className="mb-3">
                    <p className="text-white mb-2">
                      <i
                        className="fas fa-calendar-alt me-2"
                        style={{ color: "var(--metro-yellow)" }}
                      ></i>
                      Course can be divided into:
                    </p>
                    <ul className="text-white mb-0 ms-4 ps-3">
                      <li className="mb-2">
                        Saturday and Sunday (6 hours per day)
                      </li>
                      <li className="mb-2">
                        Three week nights (4 hours per day)
                      </li>
                    </ul>
                  </div>
                  <div className="mb-0">
                    <i
                      className="fas fa-user-check me-2"
                      style={{ color: "var(--metro-yellow)" }}
                    ></i>
                    <span className="text-white">
                      Evaluation is held in private for 1 hour with an evaluator
                    </span>
                  </div>
                </div>

                <div className="mb-4">
                  <h3 className="mb-3" style={{ color: "var(--metro-yellow)" }}>
                    Price
                  </h3>
                  <p className="text-white mb-2">
                    <span
                      className="fs-3 fw-bold me-2"
                    >
                      $358.00
                    </span>
                  </p>
                  <p className="text-white mb-0">
                    DUI Program fees are set by the Florida Department of
                    Highway Safety & Motor Vehicles
                  </p>
                </div>

                <div className="mb-4">
                  <h3 className="mb-3" style={{ color: "var(--metro-yellow)" }}>
                    Proof of Enrollment
                  </h3>
                  <p className="text-white mb-0">
                    Immediately after registering for our program, a Proof of
                    Enrollment will be emailed to you. You will also have the
                    option of printing it at any time. This Proof of Enrollment
                    may be used to apply for a hardship license.
                  </p>
                </div>

                <div className="mb-4">
                  <p className="text-white mb-3">
                    For detailed information about our program,{" "}
                    <Link
                      to="/dui-school-details"
                      className="text-decoration-none"
                      style={{ color: "var(--metro-yellow)" }}
                    >
                      please click here
                    </Link>
                    .
                  </p>
                </div>

                <div className="text-center">
                  <Link
                    to="http://www.duiweb.org/content/new_enrollment.asp"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-lg px-4 py-3 fw-bold text-dark metro-btn-primary text-decoration-none"
                  >
                    <i className="fas fa-user-plus me-2"></i>
                    Register Now!
                  </Link>
                </div>
              </ShellCard>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DuiLevel1;
